import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { DeleteOAuthCredentialsRequest } from '../serverApi/requests/OAuth/DeleteOAuthCredentialsRequest';
import { GetCommonUserOAuthCredentialRequest } from '../serverApi/requests/OAuth/GetCommonUserOAuthCredentialRequest';
import { GetOAuthCredentialsRequest, GetValidOAuthCredentialsRequest, IGetOAuthCredentialsResult } from '../serverApi/requests/OAuth/GetOAuthCredentialsRequest';
import { TestOAuthCredentialRequest } from '../serverApi/requests/OAuth/TestOAuthCredentialRequest';
import { IOAuthCredential, IOAuthCredentialTypeInfo } from '../serverApi/types/OAuth/IOAuthCredential';
import { OAuthCredentialsService } from '../services/OAuthCredentialsService';

class OAuthCredentialsResource {
  private listFetcher = new WebClientListResourceFetcher(GetOAuthCredentialsRequest, (result: IGetOAuthCredentialsResult) => result.credentials);

  private listFetcherValid = new WebClientListResourceFetcher(GetValidOAuthCredentialsRequest, (result: IGetOAuthCredentialsResult) => result.credentials);

  public all(): ResourceQuery<IOAuthCredential> {
    return new ResourceQuery(this.listFetcher);
  }

  public allValid(): ResourceQuery<IOAuthCredential> {
    return new ResourceQuery(this.listFetcherValid);
  }

  public del(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteOAuthCredentialsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public test(id: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new TestOAuthCredentialRequest(id));
  }

  public commonCredentialForDatasources(datasourceIds: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetCommonUserOAuthCredentialRequest({
      ids: datasourceIds
    }));
  }

  public canAddForConnectionType(oAuthCredentialTypeInfo: IOAuthCredentialTypeInfo): boolean {
    return OAuthCredentialsService.canAddForConnectionType(oAuthCredentialTypeInfo.type);
  }
}

export const OAuthCredentials = new OAuthCredentialsResource();
